import { render, staticRenderFns } from "./SearchSearch.vue?vue&type=template&id=3832ff09&"
import script from "./SearchSearch.vue?vue&type=script&lang=js&"
export * from "./SearchSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports